// NATIVE MODULES

import { NgModule } from '@angular/core';

// PRIMENG MODULES

import { TableModule } from 'primeng/table';
import { SliderModule } from 'primeng/slider';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { RatingModule } from 'primeng/rating';
import { ProgressBarModule } from 'primeng/progressbar';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { MessageService } from 'primeng/api';
import { PanelModule } from 'primeng/panel';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AccordionModule } from 'primeng/accordion';
import { TooltipModule } from 'primeng/tooltip';
import { GalleriaModule } from 'primeng/galleria';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CheckboxModule } from 'primeng/checkbox';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ListboxModule } from 'primeng/listbox';
import { SidebarModule } from 'primeng/sidebar';
import { SelectButtonModule } from 'primeng/selectbutton';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ColorPickerModule } from 'primeng/colorpicker';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MenuModule } from 'primeng/menu';
import { ContextMenuModule } from 'primeng/contextmenu';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { TreeModule } from 'primeng/tree';
import { TreeSelectModule } from 'primeng/treeselect';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ChipsModule } from 'primeng/chips';
import { ChipModule } from 'primeng/chip';
import { SplitButtonModule } from 'primeng/splitbutton';
import { InputMaskModule } from 'primeng/inputmask';
import { StepsModule } from 'primeng/steps';
import { SkeletonModule } from 'primeng/skeleton';
import { MessageModule } from 'primeng/message';
import { TagModule } from 'primeng/tag';
import { SplitterModule } from 'primeng/splitter';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { DividerModule } from 'primeng/divider';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { CardModule } from 'primeng/card';

@NgModule({
  declarations: [],
  imports: [
    TableModule,
    SliderModule,
    DropdownModule,
    InputTextModule,
    MultiSelectModule,
    RatingModule,
    ProgressBarModule,
    TabViewModule,
    DialogModule,
    ToastModule,
    CalendarModule,
    FileUploadModule,
    PanelModule,
    AutoCompleteModule,
    AccordionModule,
    TooltipModule,
    GalleriaModule,
    InputTextareaModule,
    InputSwitchModule,
    CheckboxModule,
    ToggleButtonModule,
    ListboxModule,
    SidebarModule,
    SelectButtonModule,
    VirtualScrollerModule,
    KeyFilterModule,
    ColorPickerModule,
    RadioButtonModule,
    ConfirmDialogModule,
    DynamicDialogModule,
    OverlayPanelModule,
    MenuModule,
    ContextMenuModule,
    TieredMenuModule,
    AvatarModule,
    AvatarGroupModule,
    TreeModule,
    ScrollPanelModule,
    ProgressSpinnerModule,
    ChipsModule,
    SplitButtonModule,
    InputMaskModule,
    ChipModule,
    StepsModule,
    SkeletonModule,
    MessageModule,
    TagModule,
    SplitterModule,
    ButtonModule,
    BadgeModule,
    DividerModule,
    ConfirmPopupModule,
    CardModule,
    TreeSelectModule,
  ],
  exports: [
    TableModule,
    SliderModule,
    DropdownModule,
    InputTextModule,
    MultiSelectModule,
    RatingModule,
    ProgressBarModule,
    TabViewModule,
    DialogModule,
    ToastModule,
    CalendarModule,
    FileUploadModule,
    PanelModule,
    AutoCompleteModule,
    AccordionModule,
    TooltipModule,
    GalleriaModule,
    InputTextareaModule,
    InputSwitchModule,
    CheckboxModule,
    ToggleButtonModule,
    ListboxModule,
    SidebarModule,
    SelectButtonModule,
    VirtualScrollerModule,
    KeyFilterModule,
    ColorPickerModule,
    RadioButtonModule,
    ConfirmDialogModule,
    DynamicDialogModule,
    OverlayPanelModule,
    MenuModule,
    ContextMenuModule,
    TieredMenuModule,
    AvatarModule,
    AvatarGroupModule,
    TreeModule,
    ScrollPanelModule,
    ProgressSpinnerModule,
    ChipsModule,
    SplitButtonModule,
    InputMaskModule,
    ChipModule,
    StepsModule,
    SkeletonModule,
    MessageModule,
    TagModule,
    SplitterModule,
    ButtonModule,
    BadgeModule,
    DividerModule,
    ConfirmPopupModule,
    CardModule,
    TreeSelectModule,
    MessageModule,
  ],
  providers: [MessageService, ConfirmationService],
})
export class PrimengModule {}
